import {type MechanicPirateState, type PlayerColor, TileHexType} from '@colonist/game-states'
import {type TileEdge} from '../core/map/Tile.ts'
import {type MapValidator} from '../core/map/MapValidator.ts'

export class MechanicValidatorPirate {
    private readonly mapValidator: MapValidator
    private readonly pirateState: MechanicPirateState

    constructor(mapValidator: MapValidator, pirateState: MechanicPirateState) {
        this.mapValidator = mapValidator

        this.pirateState = pirateState
    }

    private seaTilesWithoutPirate(): number[] {
        const pirateArray: number[] = []
        for(const [index, tile] of this.mapValidator.tileState.tiles.entries()) {
            if(index == this.pirateState.locationTileIndex) continue
            if(tile.tileType != TileHexType.Sea) continue

            pirateArray.push(index)
        }
        return pirateArray
    }

    whereCanPlayerPlacePirate(playersProtectedByFriendlyRobber: PlayerColor[]): number[] {
        const seaTilesWithoutRobber = this.seaTilesWithoutPirate()
        const tilesToHighlight: number[] = []

        for(const tile of seaTilesWithoutRobber) {
            if(this.mapValidator.arePlayersProtectedByFriendlyRobberTouchingTile(playersProtectedByFriendlyRobber, tile)) continue
            if(this.mapValidator.doPlayersProtectedByFriendlyRobberHaveShipTouchingTile(playersProtectedByFriendlyRobber, tile)) continue
            tilesToHighlight.push(tile)
        }

        if(tilesToHighlight.length == 0) tilesToHighlight.push(this.pirateState.locationTileIndex)

        return tilesToHighlight
    }

    isEdgeTouchingTileWithPirate(tileEdge: TileEdge): boolean {
        for(const touchingHexFaces of tileEdge.hexEdge.touchingFaces()) {
            const tileIndex = this.mapValidator.tileState.getTileHexIndex(touchingHexFaces)
            if(tileIndex == undefined) continue

            if(tileIndex == this.pirateState.locationTileIndex) return true
        }
        return false
    }
}
